<TabPanel
    id="groupsSection"
    labelledBy="groupsTab"
    preloadContent={false}
    type="container"
>
    <SearchableList
        bind:allChecked={allChecked}
        bind:items={items}
        {searchFunction}
        {searchLabel}
        {searchPlaceholder}
        {searchValue}
        {groups}
        searchFor={searchForGroups}
        showSearchInput={groups.total > 0}
        emptyStateDetails={emptyStateDetails}
        linkDetails={linkDetails}
    >
        <AssignToModalGroupHeader slot="headerTemplate" />
        <AssignToModalGroupRow slot="rowTemplate" let:item item={item} />
    </SearchableList>
</TabPanel>

<script>
    import TabPanel from "@itslearning/prometheus/assets/Navigation/Tabs/v1/TabPanel.svelte";
    import SearchableList from "@its-ui/planner-common/components/SearchableList/SearchableList.svelte";
    import i18n from "@its-ui/planner-common/i18n";
    import AssignToModalGroupHeader from "./AssignToModalGroupHeader.svelte";
    import AssignToModalGroupRow from "./AssignToModalGroupRow.svelte";
    import { onMount } from "svelte";
    import { searchableListFor } from '../../../../../constants';
    import config from "../../../../../config";

    let allChecked = false;
    let items = [];

    const searchFunction = (searchTerm) => (item) => item.title.toLowerCase().includes(searchTerm.toLowerCase());
    const searchValue = "";

    export let groups;

    let emptyStateDetails = {
        description: groups.total > 0 ? i18n.assignToTerms.noResultsGroupsDescription : i18n.assignToTerms.noGroupsInCourseOrOrganizationDescription,
        title: groups.total > 0 ? i18n.assignToTerms.noResultsTitle : i18n.assignToTerms.noGroups,
        icon: groups.total > 0 ? "search-no-result" : "user-groups",
    };
    let linkDetails = {
        id: "add-groups",
        kind: "standalone",
        text: i18n.assignToTerms.addGroups,
        url: config.addParticipantsPageUrlOpenFromGroupsPage,
    };

    const searchLabel = i18n.searchForGroups;
    const searchPlaceholder = i18n.searchForGroups;
    const searchForGroups = searchableListFor.Groups;

    $: {
        for (const item of items) {
            groups.entityArray.find((group) => group.groupId === item.groupId).isAssigned = item.checked;
        }
    }

    $: allChecked = items.every((item) => item.isAssigned);

    onMount(async () => {
        items = groups.entityArray.map((item) => ({ ...item, checked: item.isAssigned }));
    });
</script>
